import { Paginated } from '@/lib/interface';
import dayjs from 'dayjs';

export const formatDates = (paginatedData?: Paginated<{ createdAt: Date; updatedAt?: Date }>) => {

  if (!paginatedData) {
    return paginatedData;
  }

  return {
    ...paginatedData,
    data: (
      [...(paginatedData?.data ?? [])]
        .map(
          l => {
            return ({
              ...l,
              createdAt: dayjs(l.createdAt).toDate(),
              updatedAt: (
                l.updatedAt
                  ? dayjs(l.updatedAt).toDate()
                  : undefined
              )
            });
          }
        )
    )
  };

};
